import React from "react";
import { Grid, CardContent } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import FormInput from "../../common/FormInput";
import FormInputPassword from "../../common/FormInputPassword";

interface LoginFormInputsProps {
  preControlCustomisation?: React.ReactNode;
}

const LoginFormInputs: React.FC<LoginFormInputsProps> = ({
  preControlCustomisation,
}) => {
  const { t } = useTranslation();
  return (
    <CardContent>
      <Grid
        container
        direction="column"
        justify="center"
        alignContent="center"
        alignItems="center"
      >
        {preControlCustomisation && <Grid item>{preControlCustomisation}</Grid>}

        <Grid
          container
          direction="column"
          alignContent="stretch"
          wrap="nowrap"
          spacing={2}
        >
          <Grid item>
            <FormInput type="text" name="email" label={t("label.email")} />
          </Grid>
          <Grid item>
            <FormInputPassword name="password" label={t("label.password")} />
          </Grid>
        </Grid>
      </Grid>
    </CardContent>
  );
};

export default LoginFormInputs;
